import { NgModule } from '@angular/core';
import { RangeCalendarComponent } from '@app/shared/ui/components/inputs/range-calendar/range-calendar.component';
import { MatDatepickerModule } from '@angular/material/datepicker';

@NgModule({
	declarations: [RangeCalendarComponent],
	imports: [MatDatepickerModule],
	exports: [RangeCalendarComponent]
})
export class RangeCalendarModule {}
